import { Injectable } from "@angular/core";

//import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs/Rx';
import { Response } from '@angular/http';
import { HttpService } from '../../../shared/http.service';
import { AppSettings } from '../../../shared/app-settings'
import { INofeshDdlData } from "../../model/nofesh-ddl-data";
import { INofesh } from "../../model/nofesh";
import { ConfigService } from "app/shared/config.service";
@Injectable()
export class AddNofeshService {

    constructor(private _http: HttpService,private _configService: ConfigService) 
    {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
    }
    apiUrl: string = "";
    getNofeshDdlData(): Observable<INofeshDdlData> {
        let url: string = `${this.apiUrl}/api/Nofesh/GeNofeshTypeDDL`
        return this._http.get(url)
            .map((response: Response) => <INofeshDdlData>response.json())
            .catch(this.handleError);
    }

    addNofesh( addNofesh:INofesh): Observable<INofesh> {
        let url: string  = `${this.apiUrl}/api/Nofesh/AddNofesh`
        return this._http.post(url, JSON.stringify(addNofesh))
            .map((response: Response) => <INofesh>response.json())
            .catch(this.handleError);
    }

    getNofesh(id_nofesh:Number): Observable<INofesh>{
        let url: string = `${this.apiUrl}/api/Nofesh/getNofesh`
        return this._http.get(url + '/' + id_nofesh, JSON.stringify(id_nofesh))
            .map((response: Response) => <INofesh>response.json())
            
            .catch(this.handleError);
    }
    getAllNofashim(): Observable<INofesh[]> {
        let url: string = `${this.apiUrl}/api/Nofesh/getAllNofashim`
        return this._http.get(url)
        .map((response: Response) => <INofesh[]>response.json())
        .catch(this.handleError);
    }

    // saveNofeshCilabusFile(model:any):Observable<any>{
    //     debugger;
        
    //     return this._http.post(AppSettings.saveNofeshCilabus,model)
    //     .map((response: Response) => <any>response.json())
    //     .catch(this.handleError);
    // }


    private handleError(error: Response | any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);

            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        //console.error(errMsg);
      return Observable.throwError(errMsg);
    }
}
